import { useEffect, useMemo, useState } from 'react'
import WojewodztwoService from '@/services/WojewodztwoService'

export default function useWojewodztwoFilterModal(isOpen, selectedWojewodztwoId) {
	const [searchTerm, setSearchTerm] = useState('')
	const [items, setItems] = useState([])
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)
	const [activeId, setActiveId] = useState(selectedWojewodztwoId || '')

	useEffect(() => {
		if (!isOpen) return
		setActiveId(selectedWojewodztwoId || '')
	}, [isOpen, selectedWojewodztwoId])

	useEffect(() => {
		if (!isOpen) return
		let cancelled = false
		const loadItems = async () => {
			setLoading(true)
			setError(null)
			const query = (searchTerm || '').trim()
			const options = { limit: 200, sortColumn: 'nazwa', sortDirection: 'asc' }
			const result = query
				? await WojewodztwoService.search(query, options)
				: await WojewodztwoService.getAll(options)
			if (cancelled) return
			if (result?.error) {
				setError(result.error)
				setItems([])
			} else {
				setItems(Array.isArray(result?.data) ? result.data : [])
			}
			setLoading(false)
		}
		const timer = setTimeout(loadItems, 200)
		return () => {
			cancelled = true
			clearTimeout(timer)
		}
	}, [isOpen, searchTerm])

	const selectedName = useMemo(() => {
		const selected = items.find(item => (item?._id || item?.id) === activeId)
		return selected?.nazwa || ''
	}, [items, activeId])

	return { searchTerm, setSearchTerm, items, loading, error, activeId, setActiveId, selectedName, clearFilter: () => setActiveId('') }
}
